import React from 'react';

export default () =>
    <div
        className="embed-responsive h-100">
        <iframe
            title="Prevención"
            className="embed-responsive-item"
            src="https://www.gob.pe/institucion/minsa/campa%C3%B1as/8255-todo-lo-que-necesitas-saber-sobre-el-dengue"
        ></iframe>
    </div>